module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_studio-photo-8e64018f2fe6151c7e04e103e2130a40.png";